import React, { useContext, useEffect, useState } from 'react'
import CardComponent from '../components/Card'
import { WhiskeyContext } from '../App'
import Hero from '../components/Hero'
import getAllRatings from '../firebase/getAllRatings'
import getAllComments from '../firebase/getAllComments'


const StartView = () => {


    const whiskeys = useContext(WhiskeyContext)
    const [ratings, setRatings] = useState([])
    const [comments, setComments] = useState([])
    const [todaysWhiskey, setTodaysWhiskey] = useState({
        id: 1,
        date: {
            seconds: Date.now() / 1000
        },
        image: "https://product-cdn.systembolaget.se/productimages/24604678/24604678_800.webp",
        name: "Tack för i år och god jul!",
        subName: "Inom ett par veckor så kommer det finnas en chans att skriva upp sig på intresselista till nästa år samt en utvärdering!",
        logo: "\Kopia av logga white med text.png"
    }
    )
    let _todaysWhiskey = []
    useEffect(() => {
        const setTitleOfHTML = () => {
            document.title = "Whiskeykalendern"
        }
        setTitleOfHTML()
        getTodaysWhiskey()
        getWhiskeyRatingsAndGetComments()


    }, [])

    const getTodaysWhiskey = () => {
        const year = new Date().getFullYear()
        const month = new Date().getMonth() + 1
        const day = new Date().getDate().toString().padStart(2, "0")
        const currentDate = year + "-" + month + "-" + day
        const _whiskeys = whiskeys
        _todaysWhiskey = _whiskeys.filter((w) => {
            const compareDate = new Date(w.date.seconds * 1000).toLocaleDateString('sv-se')
            if (currentDate === compareDate) {
                return w
            }
            else {

                return
            }
        })

        _todaysWhiskey.length > 0 && setTodaysWhiskey({ ..._todaysWhiskey[0] })

    }


    const getWhiskeyRatingsAndGetComments = async () => {
        setRatings(await getAllRatings())
        setComments(await getAllComments())

        // const { ratings1, ratings2, ratings3, score } = await getRatings(whiskey.id)
        // if (!score) { return setRating("-") } else { setRating(Math.round(score * 10) / 10) }
        // const _comments = await readComments(whiskey.id)
        // setComments(_comments.length)

    }





    return (

        <div className='container pb-28'>
            {/* <ModalComponent /> */}
            <div className=''>
                {/* <SwiperComponent whiskeys={whiskeys} /> */}

                {todaysWhiskey && <Hero todaysWhiskey={todaysWhiskey} />}
            </div>
            {ratings &&
                <div className='grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-3 w-full px-5'>

                    {whiskeys.map(w => <CardComponent key={w.id} whiskey={w} ratings={ratings.filter(r => r.whiskeyId === w.id)} comments={comments.filter(c => c.whiskeyId === w.id)} setRatings={setRatings} />)}
                </div>}
            {/* <div className='mt-10'>
                <Link to="/login" className='hover:underline text-xl text-center'><p>Gå till loginsidan</p></Link>

            </div> */}

            {/* <CardComponent /> */}
            {/* <CardComponent /> */}
        </div>)


}

export default StartView